<template>
  <section>
    <div class="row">
      <div class="col-md-12 text-center">
        <h5>Session Statistics<span v-if="isSmoothed"> (smoothed)</span></h5>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <div class="row">
          <label for="workoutStartTime" class="col-sm-6 col-form-label"
            >Workout Start Time</label
          >
          <div class="col-sm-6">
            <input
              type="text"
              id="workoutStartTime"
              readonly
              class="form-control-plaintext"
              v-model="session.SessionDate"
            />
          </div>
        </div>
        <div class="row">
          <label for="totalTime" class="col-sm-6 col-form-label"
            >Total Time</label
          >
          <div class="col-sm-6">
            <input
              type="text"
              id="totalTime"
              readonly
              class="form-control-plaintext"
              v-model="session.TotalTime"
            />
          </div>
        </div>
        <div class="row">
          <label for="liveWorkout" class="col-sm-6 col-form-label"
            >Live Workout?</label
          >
          <div class="col-sm-6">
            <input
              type="text"
              id="liveWorkout"
              readonly
              class="form-control-plaintext"
              v-model="session.LiveWorkout"
            />
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="row">
          <label for="calories" class="col-sm-6 col-form-label">Calories</label>
          <div class="col-sm-6">
            <input
              type="text"
              id="calories"
              readonly
              class="form-control-plaintext"
              v-model="session.Calories"
            />
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="row">
          <label for="maxHR" class="col-sm-6 col-form-label">Max HR</label>
          <div class="col-sm-6">
            <input
              type="text"
              id="maxHR"
              readonly
              class="form-control-plaintext"
              v-model="session.MaxHR"
            />
          </div>
        </div>
        <div class="row">
          <label for="avgHR" class="col-sm-6 col-form-label">Avg HR</label>
          <div class="col-sm-6">
            <input
              type="text"
              id="avgHR"
              readonly
              class="form-control-plaintext"
              v-model="session.AvgHR"
            />
          </div>
        </div>
        <div class="row">
          <label for="avgHRpercent" class="col-sm-6 col-form-label"
            >Avg HR %</label
          >
          <div class="col-sm-6">
            <input
              type="text"
              id="avgHRpercent"
              readonly
              class="form-control-plaintext"
              v-model="session.PercentHR"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'session-statistics',
  computed: {
    ...mapGetters('usercardio', ['member', 'memberSession']),
    isSmoothed() {
      let _is = false
      if (this.memberSession) {
        if (this.memberSession.session.SmoothFlag === '1') {
          _is = true
        }
      }
      return _is
    },
    session() {
      let _data = {
        SessionDate: '',
        TotalTime: '',
        LiveWorkout: '',
        Calories: 0,
        MaxHR: 0,
        AvgHR: 0,
        PercentHR: 0,
      }
      if (this.memberSession) {
        _data = this.memberSession.session
      }
      return _data
    },
  },
}
</script>
<style scoped>
</style>
